import { render, staticRenderFns } from "./SustSelectField.vue?vue&type=template&id=189296ae&scoped=true"
import script from "./SustSelectField.vue?vue&type=script&lang=js"
export * from "./SustSelectField.vue?vue&type=script&lang=js"
import style0 from "./SustSelectField.vue?vue&type=style&index=0&id=189296ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189296ae",
  null
  
)

export default component.exports